module.exports = __webpack_public_path__ + "static/About-1af500aa8349735f6d63d53cd9563848.jpg";